import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { General } from "../../siteManagement/general";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { SheetEventType } from "../../siteManagement/sheet";
import { EventType } from "../../siteManagement/eventManager";
import React from "react";
export default class PriceListApp extends React.Component<PriceListProps, any> {
    common = new AppHelper();
    translations: {};
    constructor(props) {
        super(props);        
        this.common.enableHooks = true;
        this.common.init(this);
        this.initApp();
    }

    private initApp = () => {
        this.props.context.translations = this.translations;
        HTTPService.get<JsonResultClass>("Currency/GetCurrentCurrency").then((result) => {
            this.props.context.currentCurrency = result.Data.Currency;
        })
    }


    save = (closeAfterSave) => {
        if (this.common.validate()) {
            HTTPService.post("PriceList/Save", { model: this.props.entity }).then((result) => {
                if (result.Code === 0) {
                    NotificationHelper.showSuccessMessage(result.Message);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
                this.common.handlePostSave(result.Code === 0, closeAfterSave);
                this.setState({});
            })
        }
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    
    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }

}

interface PriceListProps extends AppBaseProps{
    context: PriceListContext;
}

interface PriceListContext extends Context {
    currentCurrency: string;
    currencies: any[]
    groups: any[];
    translations: {};
}